<template>
  <div class="slider-navigation">
    <div class="navigation-title">{{ t('onPhoto') }}</div>
    <div class="navigation-content">
      <a
        v-hero-location-view-tracker
        v-hero-location-click-tracker
        class="navigation-city"
        :href="currentSlide.link"
        target="_blank"
        >{{ currentSlide.name }}</a
      >
      <div class="navigation-buttons">
        <IconBase class="navigation-button" name="navigation-left-arrow" @click="$emit('prev')" />
        <IconBase class="navigation-button mirror" name="navigation-left-arrow" @click="$emit('next')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@experience/i18n';

import ru from '@/shared/i18n/ru';
import IconBase from '@/shared/icons/IconBase.vue';
import { useAnalytics } from '@/shared/lib/analytics';

type MessageSchema = typeof ru;
const { t } = useI18n<{ message: MessageSchema }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});

interface SliderItem {
  name: string;
  link: string;
  img: string;
}

defineProps<{
  currentSlide: SliderItem;
}>();

defineEmits<{
  prev: [];
  next: [];
}>();

const { useViewTracker, useImmediateClickTracker } = useAnalytics();

const vHeroLocationViewTracker = useViewTracker('main:hero-location.view');
const vHeroLocationClickTracker = useImmediateClickTracker('main:hero-location.click');
</script>

<style lang="scss" scoped>
.slider-navigation {
  display: flex;
  flex-direction: column;
  max-width: 240px;

  @include adaptivity.tablet {
    max-width: 100%;
  }

  @include adaptivity.mobile {
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 60px;
  }
}

.navigation-title {
  color: var(--alias-color-text-inverse);
  white-space: nowrap;

  @include typography.base-300-200-regular;
}

.navigation-content {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  align-items: center;

  @include adaptivity.mobile {
    width: 100%;
    margin-left: 4px;
  }
}

.navigation-city {
  color: var(--alias-color-text-inverse);
  text-decoration: underline solid var(--alias-color-link-underline-inverted) auto;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  text-underline-offset: auto;
  cursor: pointer;

  @include typography.base-400-400-semi;

  @include adaptivity.mobile {
    @include typography.base-300-300-semi;
  }
}

.navigation-buttons {
  display: flex;
  align-items: center;

  @include adaptivity.mobile {
    margin-left: auto;
  }
}

.navigation-button {
  margin: 6px;
  cursor: pointer;
}

.mirror {
  transform: scaleX(-1);

  @include adaptivity.mobile {
    margin-right: 0;
  }
}
</style>
